import rayTech from "../../images/Raytec-logo.svg"

export const logoAssets = {
  logoSet: {
    nasscom: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/logo/NASSCOM.webp`,
    rayTech: rayTech,
    bonusway: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/logo/Bonusway.webp`,
    festivity: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/logo/Festivity.webp`,
    volkswagen: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/logo/Volkswagen.webp`,
    unitedNations: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/logo/united-nations.webp`,
    paceFunding: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/logo/PaceFunding.webp`,
    paceFunding1: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/logo/PaceFunding.webp`,
    rawbank: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/logo/Rawbank.webp`,
    delMonte: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/logo/DelMonte.webp`,
  },
};
